import React from 'react';
import { Page } from '../../components/Routing/Page';
import { ImageBlock } from '../../components/Blocks/ImageBlock';

import bg from "../../assets/photo-1484557052118-f32bd25b45b5.jpg"
import pc from "../../assets/pc.png"
import laptop from "../../assets/laptop.png"
import { Breakpoint } from '../../components/Breakpoint/Breakpoint';
import { ItemParallax } from '../../components/Parallax/ItemParallax';
import "./sat.scss";

export class Sat extends React.PureComponent
{
	
	render()
	{
		return (
			// <Page id="sat" title="System3" noCrawl >
			<div id="sat" >
				<ImageBlock overlay src={bg} strength={500} >
					<ItemParallax medium up className="title" speed={.1} >
						<h2>Tranquilidad para ti<span className="highlight">y tu <span>empresa</span></span></h2>
					</ItemParallax>
					<ItemParallax medium up className="subtitle" speed={.1} >
						<h3>Servicio de asistencia técnica</h3>
					</ItemParallax>
					<ItemParallax medium up className="description" speed={.1} >
						<p>
							En System<span>3</span> nos encargamos de que ningún imprevisto robe <span>tu tiempo</span>.{'\n\n'}Nuestro servicio de mantenimiento para <span>empresas y particulares</span> cubre todas las necesidades con tus dispositivos digitales.
						</p>
					</ItemParallax>
					<Breakpoint medium up>
						<ItemParallax  id="laptop" speed={.6} >
							<img src={laptop}  />
						</ItemParallax>
						<ItemParallax id="pc" speed={.6} >
							<img  src={pc}  />
						</ItemParallax>
					</Breakpoint>
					<ItemParallax medium up className="service-ul" speed={.1} >
						<h3>
							Servicio de mantenimiento
						</h3>
						<ul>
							<li>
								Servicio prioritario de reparación
							</li>
							<li>
								Asistencia remota
							</li>
							<li>
								Envío y recogida de dispositivos
							</li>
							<li>
								Servicio prioritario de instalaciones 
							</li>
						</ul>
					</ItemParallax>
				</ImageBlock>
			</div>
		);
	}
}